// @flow
import { RESORT_MULTIMEDIA } from 'Client/cms/toolkit/constants';
import { ProductMultimediaLine } from 'Components/lines/product-multimedia-line/ProductMultimediaLine.jsx';
import { productMultimediaResolver } from './productMultimedia.resolver';

export const productMultimediaDescriptor = {
  name: RESORT_MULTIMEDIA,
  component: ProductMultimediaLine,
  resolve: productMultimediaResolver.resolve,
};
